import { render, staticRenderFns } from "./PartnerRegistrationPage.vue?vue&type=template&id=4729f86c&scoped=true&"
import script from "./PartnerRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./PartnerRegistrationPage.vue?vue&type=script&lang=js&"
import style0 from "./PartnerRegistrationPage.vue?vue&type=style&index=0&id=4729f86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4729f86c",
  null
  
)

export default component.exports